import { AppSubdomains } from 'src/types/common';
import { specializedStoresConfig } from 'src/features/specializedStores/domain/config/specializedStores.config';
import { getSubdomain } from 'src/utils/domain/getSubdomain';
import HomeIcon from 'src/assets/home_icon.svg?react';
import CategoriesIcon from 'src/assets/categories_icon.svg?react';
import BrandsIcon from 'src/assets/brands_icon.svg?react';
import AccountIcon from 'src/assets/account_icon.svg?react';
import DiscountTagIcon from 'src/assets/discount_tag_icon.svg?react';

const getDefaultNavBarOptions = (isB2b: boolean) => [
  {
    label: 'Inicio',
    href: '/',
    icon: <HomeIcon width={27} height={27} />,
  },
  {
    label: 'Categorías',
    icon: <CategoriesIcon width={27} height={27} />,
    href: '/categories',
    disabled: false,
  },
  {
    label: 'Marcas',
    icon: <BrandsIcon width={27} height={27} />,
    href: '/brands',
    disabled:
      getSubdomain(AppSubdomains, AppSubdomains.Pari) !== AppSubdomains.Homebar,
  },
  {
    label: 'Promociones',
    icon: <DiscountTagIcon width={27} height={27} />,
    href: '/promociones',
    disabled: isB2b,
  },
  {
    label: 'Cuenta',
    icon: <AccountIcon width={27} height={27} />,
    href: '/profile',
    disabled: false,
  },
];

export const getNavBarOptions = (isB2b: boolean) => {
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);
  const defaultNavBarOptions = getDefaultNavBarOptions(isB2b);
  const storeConfig = specializedStoresConfig.find(
    (config) => config.subdomain === subdomain
  );

  if (!storeConfig) {
    return defaultNavBarOptions;
  }

  const { strategy, exceptions } = storeConfig;
  const exceptionPaths = exceptions.map((exception) => exception.path);

  return defaultNavBarOptions.filter((option) => {
    const isException = exceptionPaths.includes(option.href);
    return strategy === 'exclude' ? isException : !isException;
  });
};
